import React from 'react';

export function ContactInfoCard({ contact, contactTypeLabel, referrerLabel = '-', onBack }) {
  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Contact Info</h5>
        <button className="btn btn-sm btn-outline-secondary" onClick={onBack}>Back</button>
      </div>
      <div className="card-body">
        {!contact ? (
          <div className="text-muted">No contact found.</div>
        ) : (
          <dl className="row mb-0">
            <dt className="col-sm-4">Full Name</dt>
            <dd className="col-sm-8">{contact.contactName || '-'}</dd>

            <dt className="col-sm-4">Email</dt>
            <dd className="col-sm-8">{contact.contactEmail || '-'}</dd>

            <dt className="col-sm-4">Phone</dt>
            <dd className="col-sm-8">{contact.contactPhone || '-'}</dd>

            <dt className="col-sm-4">NID</dt>
            <dd className="col-sm-8">{contact.nid || '-'}</dd>

            <dt className="col-sm-4">Passport</dt>
            <dd className="col-sm-8">{contact.passportNumber || '-'}</dd>

            <dt className="col-sm-4">Contact Type</dt>
            <dd className="col-sm-8">{contactTypeLabel}</dd>

            <dt className="col-sm-4">Referred By</dt>
            <dd className="col-sm-8">{referrerLabel}</dd>
          </dl>
        )}
      </div>
    </div>
  );
}
